webpackJsonp([49683490770531],{

/***/ 437:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-582b2c50ebd5157dd0c7.js